import React from "react";
import "./Footer.css";
import tomowelLogo from "../assets/logo.svg";

const Footer: React.FC = () => {
  return (
    <>
      <div className="footer-divider" aria-hidden="true" />
      <footer className="footer-container" aria-label="フッターナビゲーション">
        <div className="footer-content">
          <nav className="footer-links" aria-label="フッターリンク">
            <a
              className="footer-link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.kyodoprinting.co.jp/inquiry/"
              aria-label="お問い合わせページへ移動"
            >
              <p className="footer-link-text">お問い合わせ</p>
            </a>
            <a
              className="footer-link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.kyodoprinting.co.jp/company-profile/"
              aria-label="会社概要ページへ移動"
            >
              <p className="footer-link-text">会社概要</p>
            </a>
            <a
              className="footer-link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.kyodoprinting.co.jp/agreement.html"
              aria-label="当サイトのご利用についてを見る"
            >
              <p className="footer-link-text">当サイトのご利用について</p>
            </a>
          </nav>
          <div className="footer-logo-container">
            <a
              className="footer-logo-link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.kyodoprinting.co.jp/"
              aria-label="共同印刷株式会社のホームページへ移動"
            >
              <img
                src={tomowelLogo}
                alt="共同印刷株式会社 ロゴ"
                className="footer-logo"
              />
            </a>
          </div>
        </div>
        <div className="footer-copyright">
          copyright©2026 Kyodo Printing Co., Ltd.
        </div>
      </footer>
    </>
  );
};

export default Footer;
